/** Hauptmodul
* Wichtig: Hier gehören nur Coreänderungen hinein kundenspezifische Änderungen sollen nur im Custommodul ./custom/custom.module.ts gemacht werden.
*/

import { SharedModule } from "./shared.module";
import { BrowserModule, Title, HAMMER_GESTURE_CONFIG } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, APP_INITIALIZER, ErrorHandler, Type, ModuleWithProviders, Provider } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { ScrollDispatchModule } from "@angular/cdk/scrolling";
import { OverlayContainer } from "@angular/cdk/overlay";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { GestureConfig, MatDialogRef, MatTableModule } from "@angular/material";
import { SimpleNotificationsModule } from "angular2-notifications";
import { AgmCoreModule } from "@agm/core";
import { NgxLoadingModule } from "ngx-loading";
import { MomentModule } from "ngx-moment";
import { SwiperModule, SWIPER_CONFIG } from "ngx-swiper-wrapper";
import { BarRatingModule } from "ngx-bar-rating";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { NgxInfiniteScrollerModule } from "ngx-infinite-scroller";
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { CustomModule } from "./custom/custom.module";
import { SOTModule } from "./sot/sot.module";
import { AppComponent, CustomOverlayContainer } from "./app.component";

import { MainLayoutComponent } from "./core/shared/layout/mainLayout/mainLayout.component";

import * as CoreComponents from "./core/components/index";
import * as CoreModalDialogs from "./core/modalDialogs/index";
import * as CoreDirectives from "./core/directives/index";

// todo was ist OverlaySpinnerComponent? Component oder Dialog
import { OverlaySpinnerComponent } from "./core/components/overlayspinner/overlaySpinner.component";

import { appConfig } from "./core/core-config";
// Services
import { CoreLogService } from "./core/services/log.service";
import { CoreCOMService } from "./core/services/com.service";
import { CoreLanguageService } from "./core/services/language.service";
import { CoreLanguageManagerService } from "./core/services/languageManager.service";
import { CoreSystemService } from "./core/services/system.service";
import { CoreGlobalErrorHandlerService } from "./core/services/globalerrorhandler.service";
import { CoreUpdateService } from "./core/services/update.service";
import { ValueStorageService } from "./core/services/valueStorage.service";
import { CircularInjectionHelper } from "./core/services/circularInjectionHelper";
import { RouterHelperService } from "./core/services/routerHelper.service";
import { WebVoucherService } from "./core/services/web_voucher.service";
import { ReservationSettingService } from "./core/services/reservationSetting.service";
import { EMenuService } from "./core/services/emenu.service";
import { CommunicationData } from "./core/services/communicationdata.service";
//import { RoutingStrategy } from "./core/services/system/systemRoutingStrategy";
import { INHOUSEORDER_SERVICE_INJECTION_TOKEN } from "./injectionToken";
import { InHouseOrderService } from "./core/services/inHouseOrder.service";

import { DateCountdownComponent } from "./core/forked/dateCountdown/dateCountdown.component";
import { InternationalisationModule } from "./core/forked/angular-internationalisation";
import { InlineSVGModule } from "./core/forked/ng-inline-svg";
import { AppMaterialModule } from "./core/app-material/app-material.module";

import { routing } from "./app.routing";
import { Globals } from "./globals";
// providers
import { RatingValueValidatorDirective, EmailValidatorDirective, EmailConfirmationDirective, PasswordValidatorDirective, CustomUserNameValidatorDirective, DynamicFieldValidatorDirective } from "./core/shared/validator/validator.directive";
import { statusBarBackgroundProviderFactory, statusBarTextProviderFactory, backgroundColorByHexString, appInitializeProviderFactory } from "./core/providers/appInitializerProviderFactory";
import { UserLoginStatusProvider } from "./core/providers/userLoginStatusProvider";
import { StatusBarProvider } from "./core/providers/statusBarProvider";
import { NavigationBarProvider } from "./core/providers/NavigationBarProvider";

import { CapitalizedPipe } from "./core/shared/filter/filterHelper";
import { GeocodingService } from "./core/services/geocoding.service";
import { MetaPixelService } from "./core/services/tracking/meta-pixel.service";
import { TRACKER_TOKEN } from './core/services/tracking/tracker.token';
import { RemoteGroupOrderService } from "./core/services/RemoteGroupOrder.service";

// hammer.js
export class MyHammerConfig extends GestureConfig {
  buildHammer(element: HTMLElement) {
    return new GestureConfig(appConfig.hammerjs).buildHammer(element);
  }
}

export function initOverlay() {
  return new CustomOverlayContainer();
}

// Module
const imports: Array<Type<any> | ModuleWithProviders | any[]> = [
  SharedModule,
  BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  ReactiveFormsModule,
  SimpleNotificationsModule.forRoot(),
  MomentModule,
  HttpClientModule,
  routing,
  NgxLoadingModule.forRoot(appConfig.ngxLoading),
  InternationalisationModule,
  AppMaterialModule,
  CustomModule,
  SwiperModule,
  AgmCoreModule.forRoot({
    apiKey: "AIzaSyC5cBQ7bdIAoRVWyw9elQ0QqvpTZGxSGqs"
  }),
  InlineSVGModule.forRoot({ baseUrl: "assets/core/svg/" }),
  BarRatingModule,
  AngularFontAwesomeModule,
  NgxInfiniteScrollerModule,
  MatMomentDateModule,
  ScrollDispatchModule,
  ZXingScannerModule,
  MatTableModule,
  SOTModule
];

// Exports
const mExports: Array<Type<any> | any[]> = [
];

// Provider
const providers: Provider[] = [
  CoreLogService,
  CoreLanguageService,
  CoreCOMService,
  CoreLanguageManagerService,
  CoreSystemService,
  CoreUpdateService,
  CommunicationData,
  Title,
  { provide: "angularLocation", useValue: location },
  { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
  { provide: ErrorHandler, useClass: CoreGlobalErrorHandlerService },
  Globals,
  { provide: SWIPER_CONFIG, useValue: appConfig.defualSwiperConfig },
  ValueStorageService,
  CircularInjectionHelper,
  { provide: APP_INITIALIZER, useFactory: appInitializeProviderFactory, deps: [CoreCOMService, UserLoginStatusProvider], multi: true },
  /* !ATTENTION! only appInitializeProviderFactory is allowed to access storage in "provide:APP_INITIALIZER" */
  { provide: APP_INITIALIZER, useFactory: statusBarBackgroundProviderFactory, deps: [StatusBarProvider], multi: true, },
  { provide: APP_INITIALIZER, useFactory: statusBarTextProviderFactory, deps: [StatusBarProvider], multi: true, },
  { provide: APP_INITIALIZER, useFactory: backgroundColorByHexString, deps: [NavigationBarProvider], multi: true, },
  { provide: OverlayContainer, useFactory: initOverlay },
  { provide: LocationStrategy, useClass: HashLocationStrategy },
  WebVoucherService,
  ReservationSettingService,
  { provide: MatDialogRef, useValue: {} }, // um dialoge aus service öffnen zu können (wie ReconnectDialogComponent)
  InHouseOrderService,
  { provide: INHOUSEORDER_SERVICE_INJECTION_TOKEN, useExisting: InHouseOrderService }, // to split from app.component.ts,
  GeocodingService,
  { provide: TRACKER_TOKEN, useExisting: MetaPixelService, multi: true },
  RemoteGroupOrderService,
];

// Deklarationen for modal dialog Component
const entryComponents: Array<Type<any> | any[]> = [
  OverlaySpinnerComponent,

  CoreModalDialogs.RatingDialogComponent,
  CoreModalDialogs.CouponQRCodeDialogComponent,
  CoreModalDialogs.FilterLocationDialogComponent,
  CoreModalDialogs.LoginDialogComponent,
  CoreModalDialogs.DeleteAccountDialogComponent,
  CoreModalDialogs.TermDialogComponent,
  CoreModalDialogs.RegistrationLocationDialogComponent,
  CoreModalDialogs.LanguageDialogComponent,
  CoreModalDialogs.WebvoucherDialogComponent,
  CoreModalDialogs.BonusWebvocherDialogComponent,
  CoreModalDialogs.SelectLocationDialogComponent,
  CoreModalDialogs.SecureCheckDialogComponent,
  CoreModalDialogs.AgeConfirmDialogComponent,
  CoreModalDialogs.ConfirmationModalDialogComponent,
  CoreModalDialogs.ContinueShoppingDialogComponent,
  CoreModalDialogs.RemoteGroupContinueOrderDialogComponent,
  CoreModalDialogs.AvailableServiceTimeComponent,
  CoreModalDialogs.MenuChangeLocationDialogComponent,
  CoreModalDialogs.WarningdialogComponent,
  CoreModalDialogs.InvalidDeliveryAddressComponent,
  CoreModalDialogs.ResetbasketwarningdialogComponent,
  CoreModalDialogs.LocationImpressumDialogComponent,
  CoreModalDialogs.AnnounceDialogComponent,
  CoreModalDialogs.SetNewOrderTimeDialogComponent,
  CoreModalDialogs.RemoteGroupOrderServiceTimeExpiredComponent,
  CoreModalDialogs.CookiePolicyComponent,
  CoreModalDialogs.FilterTagDialogComponent,
  CoreModalDialogs.MenuNavDialogComponent,
  CoreModalDialogs.LocationDialogComponent,
  CoreModalDialogs.ItemNotAvaliableDialogComponent,
  CoreModalDialogs.GroupOrderQrCodeDialogComponent,
  CoreModalDialogs.NotificationsDialogComponent,
  CoreModalDialogs.DiscardBasketDialogComponent,
  CoreModalDialogs.NotificateViaSMSDialogComponent,
  CoreModalDialogs.BasketPayOptionsDialogComponent,
  CoreModalDialogs.BasketPayConfirmDialogComponent,
  CoreModalDialogs.ErrorDialogComponent,
  CoreModalDialogs.ReconnectDialogComponent,
  CoreModalDialogs.ChangePhoneNumberDialogComponent,
  CoreModalDialogs.LocationAndOrdertypeDialogComponent,
  CoreModalDialogs.ExtraAdditionalInfoDialogComponent,
  CoreModalDialogs.TimeControlDialogComponent,
  CoreModalDialogs.AccessibiltyDialogComponent,
  CoreModalDialogs.AGBConfirmationDialogComponent,
  CoreModalDialogs.LicenseDialogComponent,
  CoreModalDialogs.RedeemBenefitDialogComponent,
  CoreModalDialogs.AddressVerificationDialogComponent,
  CoreModalDialogs.AccountPaymentRequestDialogComponent,
];

// Deklarationen
const declarations: Array<Type<any> | any[]> = [
  AppComponent,

  entryComponents,

  MainLayoutComponent,

  CoreDirectives.NumericInputDirective,
  CoreDirectives.NumericDateInputDirective,
  CoreDirectives.ArtikleLabelHeightDirective,
  CoreDirectives.InHouseTableButtonComponent,
  CoreDirectives.RemoteGroupHomeButtonComponent,
  CoreDirectives.FavoritebarComponent,
  CoreDirectives.FavoritebuttonComponent,
  CoreDirectives.BottomSheetCloseBottomComponent,
  CoreDirectives.SubheaderComponent,
  CoreDirectives.ArticleCardComponent,
  CoreDirectives.BasketItemCardComponent,
  CoreDirectives.CustomInputComponent,
  CoreDirectives.CustomInputComponent,
  CoreDirectives.CustomCalendarComponent,
  CoreDirectives.CustomSelectInputComponent,
  CoreDirectives.ErrorValidationComponent,
  CoreDirectives.FooterLabelWidthDirective,
  CoreDirectives.FormTouchedOnClickDirective,
  CoreDirectives.SelectComponent,
  CoreDirectives.ButtonPropertiesDirective,
  CoreDirectives.BannerComponent,
  CoreDirectives.DynamicFormFieldsComponent,
  CoreDirectives.QRCodeDisplayComponent,
  CoreDirectives.CalendarComponent,
  CoreDirectives.NewsletterCheckboxComponent,

  RatingValueValidatorDirective,
  EmailValidatorDirective,
  EmailConfirmationDirective,
  PasswordValidatorDirective,
  CustomUserNameValidatorDirective,
  DynamicFieldValidatorDirective,

  CapitalizedPipe,

  CoreComponents.LoginComponent, // todo, ist nur für debug
  CoreComponents.HomeComponent,
  CoreComponents.CheckoutComponent,
  CoreComponents.CookiebannerComponent,
  CoreComponents.MainNavComponent,
  CoreComponents.OnborardingComponent,
  CoreComponents.BasemapComponent,
  CoreComponents.LocationComponent,
  CoreComponents.LocationDetailComponent,
  CoreComponents.NewsComponent,
  CoreComponents.DebugViewComponent,
  CoreComponents.CouponComponent,
  CoreComponents.CouponDetailComponent,
  CoreComponents.EventComponent,
  CoreComponents.EventDetailComponent,
  CoreComponents.TermComponent,
  CoreComponents.CustomActionComponent,
  CoreComponents.RegistrationComponent,
  CoreComponents.ServiceCallComponent,
  CoreComponents.ForgetPasswordComponent,
  CoreComponents.LoginActivationComponent,
  CoreComponents.RegisterationDataComponent,
  CoreComponents.UserProfileComponent,
  CoreComponents.UserProfileDetailComponent,
  CoreComponents.ChangePasswordComponent,
  CoreComponents.UserLikesComponent,
  CoreComponents.FeedbackComponent,
  CoreComponents.UserOrderDetailComponent,
  CoreComponents.WebvoucherComponent,
  CoreComponents.WebvoucherDetailComponent,
  CoreComponents.BonusSystemComponent,
  CoreComponents.BonusSystemDetailComponent,
  CoreComponents.EmptypageComponent,
  CoreComponents.MenuComponent,
  CoreComponents.MenuGroupComponent,
  CoreComponents.MenuDetailComponent,
  CoreComponents.MenuLocationComponent,
  CoreComponents.MenuServiceSelectorComponent,
  CoreComponents.WebshopComponent,
  CoreComponents.OrderResultComponent,
  CoreComponents.QrcodeScannerComponent,
  CoreComponents.InHauseServiceSelectorComponent,
  CoreComponents.InHausePaymentComponent,
  CoreComponents.InHousePaymentOrderComponent,
  CoreComponents.InHauseOrderConfirmComponent,
  CoreComponents.InHouseOrderresultComponent,
  CoreComponents.InHouseTableOverviewComponent,
  CoreComponents.inHouseUserNameRequestComponent,
  CoreComponents.OrderModeSelectorComponent,
  CoreComponents.GroupOrderCreateGroupComponent,
  CoreComponents.GroupOrderServiceSelectorComponent,
  CoreComponents.GroupOrderGuideComponent,
  CoreComponents.GroupOrderShareComponent,
  CoreComponents.GroupOrderInviteComponent,
  CoreComponents.GroupOrderOverviewComponent,
  CoreComponents.GroupMemberOrderDetailComponent,
  CoreComponents.QRCodeInputComponent,
  CoreComponents.VoucherCreditComponent,
  CoreComponents.NewsDetailComponent,
  CoreComponents.UserAddressComponent,
  CoreComponents.BillingInfoComponent,
  CoreComponents.FixedBasketErrorPageComponent,
  CoreComponents.EmptyComponent,
  CoreComponents.BasketComponent,
  CoreComponents.CustomerDataComponent,
  CoreComponents.PhoneNumberInputComponent,
  CoreComponents.WebVoucherSelectorComponent,
  CoreComponents.WebVoucherCustomDetailComponent,
  CoreComponents.RecipeLinkComponent,
  CoreComponents.CouponRedeemComponent,
  CoreComponents.CouponCodeScannerComponent,
  CoreComponents.OrderAddressQueryComponent,
  CoreComponents.RemoteOrderModeSelector,
  CoreComponents.RemoteOrderGroupDefineName,
  CoreComponents.RemoteOrderGroupDefineTime,
  CoreComponents.RemoteOrderGroupCreateConfirmComponent,
  CoreComponents.RemoteOrderGroupShareComponent,
  CoreComponents.RemoteOrderGroupServiceSelectorComponent,
  CoreComponents.RemoteOrderGroupOverviewComponent,
  CoreComponents.RemoteOrderGroupPaymentComponent,
  CoreComponents.RemoteOrderGroupEntryComponent,
  CoreComponents.RemoteOrderGroupPayResultComponent,
  CoreComponents.RemoteOrderGroupMemberDetailComponent,
  CoreComponents.RemoteOrderGroupSummaryComponent,
  CoreComponents.OrderTimeSelectorComponent,
  CoreComponents.RevokeOrderComponent,
  CoreComponents.RevokeOrderResultComponent,
  CoreComponents.MainFooterComponent,
  DateCountdownComponent
];

// Modul
const ngModule: NgModule = {
  declarations: declarations,
  imports: imports,
  entryComponents: entryComponents,
  exports: mExports,
  providers: providers,
  bootstrap: [AppComponent]
};

@NgModule(ngModule)
export class AppModule {
  constructor(private routerHelperService: RouterHelperService
    , private eMenuService: EMenuService) {
  }
}
